import { render, staticRenderFns } from "./DadataOrgField.vue?vue&type=template&id=4686e085&scoped=true&"
import script from "./DadataOrgField.vue?vue&type=script&lang=js&"
export * from "./DadataOrgField.vue?vue&type=script&lang=js&"
import style0 from "./DadataOrgField.vue?vue&type=style&index=0&id=4686e085&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4686e085",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemContent,VListItemSubtitle,VListItemTitle})
